module.exports = __webpack_public_path__ + "static/media/icomoon.45bbcbdb.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/style/utils/icomoon/icomoon.woff2
// module id = 1896
// module chunks = 0